/**
 * Start session and keep retrying in case of any error other than 4xx
 * 
 * @param {string} url - The URL to send the request to.
 * @param {object} payload - The data to send in the request body.
 * @param {number} delay - Retry delay
 * @returns {Promise<Object>} The JSON response from the server.
 * @returns 
 */
export const startSession = (url, payload = {}, delay = 1000) => {
  return new Promise((resolve, reject) => {
    const makeRequest = async () => {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', // Specify content type
          },
          body: JSON.stringify(payload), // Convert payload to JSON string
        });

        // If the response is 4xx, reject the promise immediately
        if (response.status >= 400 && response.status < 500) {
          reject(new Error(`Client error: ${response.status}`));
          return;
        }

        // If the server responds successfully, resolve the promise
        if (response.ok) {
          resolve(await response.json()); // or response.text(), etc., depending on expected response type
          return;
        }

        // If the response is 5xx, retry
        throw new Error(`Server error: ${response.status}`);
      } catch (error) {
        // If the error is due to a 4xx, reject immediately
        if (error.message.includes('Client error')) {
          reject(error);
          return;
        }

        // Log the error and retry
        console.error(`Request failed: ${error.message}. Retrying in ${delay / 1000} seconds...`);

        // Wait and try again
        setTimeout(makeRequest, delay);
      }
    };

    makeRequest(); // Initial request attempt
  });
}
